import { render } from "./Breadcrumbs.vue?vue&type=template&id=aa19a3fe"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Breadcrumbs.vue?vue&type=style&index=0&id=aa19a3fe&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script